import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex align-center mb-4" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "d-flex align-center justify-space-between flex-wrap mb-1" }
const _hoisted_6 = { class: "d-flex align-center flex-wrap" }
const _hoisted_7 = { class: "d-flex align-center flex-wrap" }
const _hoisted_8 = { class: "d-flex align-center notice-label" }
const _hoisted_9 = { class: "list list-scrollbar prov-list" }
const _hoisted_10 = {
  key: 0,
  class: "prov-loading"
}
const _hoisted_11 = { class: "checkbox-column" }
const _hoisted_12 = ["checked", "disabled"]
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center action-column" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  colspan: "16",
  class: "text-center text-muted"
}
const _hoisted_17 = { class: "checkbox-column" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = {
  key: 0,
  class: "text-red-darken-1"
}
const _hoisted_21 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_22 = { class: "text-center action-column" }
const _hoisted_23 = { class: "force-rerun-item" }
const _hoisted_24 = { class: "filter-panel p-4" }
const _hoisted_25 = { class: "mt-0" }
const _hoisted_26 = { class: "d-grid gap-2" }
const _hoisted_27 = { class: "filter-section-label" }
const _hoisted_28 = { class: "filter-section-label" }
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "d-flex search-buttons mt-3" }

import { ref, reactive, computed, onMounted, watch, Ref } from 'vue'
import moment from 'moment'
import Api from '@/services/api/ApiServiceFabrick'
import { useAuth } from '@/services/user/Auth0UserProvider'
import i18n from '@/lang/i18n'
import { ALL_DEVICE_TYPE, TELTONIKA_MAKER_ID } from '@/services/consts'
import { PROVISIONING_CATEGORIES, getProvisioningCategory, isProvisioningRunning } from '@/services/functions/provisioningStatus'
import BulkProvisioningConfirmModal from '@/components/DeviceListParts/BulkProvisioningConfirmModal.vue'
import ManagementOfficeAutoComplete from '@/components/AutoCompletes/ManagementOfficeAutoComplete.vue'
import MultipleOperationOfficeAutoComplete from '@/components/AutoCompletes/MultipleOperationOfficeAutoComplete.vue'
import SingleDeviceTypeAutoComplete from '@/components/AutoCompletes/SingleDeviceTypeAutoComplete.vue'
import PaginateWithCount from '@/components/PaginateWithCount.vue'
import getProvisioningStatusesRequest, { ProvisioningCategory } from '@/types/requests/getProvisioningStatuses'
import executeProvisioningRequest from '@/types/requests/executeProvisioning'
import { ProvisioningDevice, ProvisioningStatus } from '@/types/responses/getProvisioningStatuses'
import getManagementOffice from '@/types/responses/getManagementOffice'
import getOperationOffice from '@/types/responses/getOperationOffice'
import deviceType from '@/types/DeviceType'

const TOPIC_PENDING_COLOR = '#f9a825'

// 強制再実行は証明書を作り直すので危険寄りの色にする
const FORCE_RERUN_COLOR = 'red-darken-2'

// ---- 一覧 ----
type FilterForm = {
  managementOffice: getManagementOffice | undefined,
  operationOffices: getOperationOffice[],
  model_number: string | null,
  fw_version: string | null,
  sim_id: string | null,
  imei: string | null,
  model_type: deviceType | undefined,
  number_plate: string | null,
  status: 'only-active' | 'all',
  categories: ProvisioningCategory[],
}

type OperationOfficeOption = getOperationOffice & {
  managementOfficeId?: number,
  managementOfficeType?: string,
}
type NormalAction = 'execute' | 'retry' | null

type BulkCategory = 'not_executed' | 'failed'
const EXECUTE_CHUNK_SIZE = 50


export default /*@__PURE__*/_defineComponent({
  __name: 'GpsTrackerProvisioning',
  props: {
    showFlash: { type: Function }
  },
  setup(__props: any) {

const props = __props

const { loginWithRedirect } = useAuth()

document.title = i18n.global.t('pages.gpsTrackerProvisioning.title')

const CATEGORY_COLORS: Record<ProvisioningCategory, string> = {
  not_executed: '#9e9e9e',
  running: '#1e88e5',
  failed: '#e53935',
  done: '#43a047',
}
// topic_pending はカテゴリ上は進行中。フィルタと並び順はサーバーに合わせ、チップだけ別表示にする
const devices: Ref<ProvisioningDevice[]> = ref([])
const currentPage = ref(1)
const totalPage = ref(0)
const listLoading = ref(false)

// ---- 右サイド検索フィルタ ----
// 管理会社はAPIに送らない。運営会社の候補を絞るためだけに使う
function createEmptyForm (): FilterForm {
  return {
    managementOffice: undefined,
    operationOffices: [],
    model_number: null,
    fw_version: null,
    sim_id: null,
    imei: null,
    model_type: undefined,
    number_plate: null,
    status: 'only-active',
    categories: [],
  }
}

const form = reactive<FilterForm>(createEmptyForm())

// 車番の候補。車両オートコンプリートAPIから取る
const numberPlateOptions: Ref<string[]> = ref([])

function loadNumberPlateOptions () {
  Api().autoComplete.vehicles().then((vehicles) => {
    const plates = vehicles
      .map((vehicle) => vehicle.number_plate)
      .filter((plate): plate is string => !!plate)
    numberPlateOptions.value = Array.from(new Set(plates)).sort()
  }).catch((error) => {
    handleError(error, 'fetchFailed')
  })
}

// autoCompleteOperationOffices が返すのは managementOfficeId を持つ形。型定義が実データと合っていないので足しておく
const operationOfficeOptions: Ref<OperationOfficeOption[]> = ref([])

// 一覧APIに管理会社の条件が無いので、管理会社だけ選ばれた時はその配下の運営会社IDに展開して送る
function resolveOperationOfficeIds (): number[] {
  if (form.operationOffices.length > 0) {
    return form.operationOffices.map((office) => office.id)
  }
  if (!form.managementOffice) {
    return []
  }
  const ids = operationOfficeOptions.value
    .filter((office) =>
      office.managementOfficeId === form.managementOffice?.id &&
      office.managementOfficeType === form.managementOffice?.type
    )
    .map((office) => office.id)
  // 配下の運営会社が無い管理会社を選んだ時に全件出てしまわないよう、存在しないIDを送って0件にする
  return ids.length > 0 ? ids : [0]
}

function buildRequest (page: number): getProvisioningStatusesRequest {
  return {
    operation_office_ids: resolveOperationOfficeIds(),
    model_number: form.model_number || null,
    fw_version: form.fw_version || null,
    sim_id: form.sim_id || null,
    imei: form.imei || null,
    model_type: form.model_type?.id ?? null,
    number_plate: form.number_plate || null,
    only_active: form.status === 'only-active',
    provisioning_categories: [...form.categories],
    page,
  }
}

// ページ送りではフォームの現在値ではなく検索した時の条件を使うので持っておく
const searchParams: Ref<getProvisioningStatusesRequest> = ref(buildRequest(1))

function fetchProvisioningStatuses (request: getProvisioningStatusesRequest): Promise<boolean> {
  listLoading.value = true
  selectedIds.value = []
  return Api().getProvisioningStatuses(request).then((data) => {
    devices.value = data.gps_tracker_provisioning_statuses
    currentPage.value = data.current_page
    totalPage.value = data.total_page
    return true
  }).catch((error) => {
    handleError(error, 'fetchFailed')
    return false
  }).finally(() => {
    listLoading.value = false
  })
}

function search (): Promise<boolean> {
  searchParams.value = buildRequest(1)
  return fetchProvisioningStatuses(searchParams.value)
}

function clearFilter () {
  Object.assign(form, createEmptyForm())
  search()
}

onMounted(() => {
  Api().autoCompleteOperationOffices().then((data) => {
    operationOfficeOptions.value = data as OperationOfficeOption[]
  }).catch((error) => {
    handleError(error, 'fetchFailed')
  })
  loadNumberPlateOptions()
  search().then((succeeded) => {
    if (succeeded) {
      loadBulkTotals()
    }
  })
})

watch(currentPage, (page) => {
  if (page === searchParams.value.page) {
    return
  }
  searchParams.value = { ...searchParams.value, page }
  fetchProvisioningStatuses(searchParams.value)
})

// ---- 表示用ヘルパー ----
function categoryOf (device: ProvisioningDevice): ProvisioningCategory {
  return getProvisioningCategory(device.provisioning_status)
}

function categoryLabel (category: ProvisioningCategory): string {
  return i18n.global.t(`pages.gpsTrackerProvisioning.categories.${category}`)
}

// 翻訳キーが無い status はそのまま表示する
function failureReasonLabel (device: ProvisioningDevice): string {
  if (device.provisioning_status === null) {
    return ''
  }
  const key = `pages.gpsTrackerProvisioning.failureReasons.${device.provisioning_status.status}`
  return i18n.global.te(key) ? i18n.global.t(key) : device.provisioning_status.status
}

function isTopicPending (device: ProvisioningDevice): boolean {
  return device.provisioning_status?.status === 'topic_pending'
}

function isRunning (device: ProvisioningDevice): boolean {
  return isProvisioningRunning(device.provisioning_status)
}

// 通常実行(force=false)のボタン。送っても必ずスキップされる実行中と完了には出さない
function normalAction (device: ProvisioningDevice): NormalAction {
  if (isRunning(device)) {
    return null
  }
  if (isTopicPending(device)) {
    return 'retry'
  }
  const category = categoryOf(device)
  if (category === 'not_executed') {
    return 'execute'
  }
  if (category === 'done') {
    return null
  }
  return 'retry'
}

// 通常実行ではスキップされる端末。完了と実行中
function isSkippedByNormalRun (device: ProvisioningDevice): boolean {
  return isRunning(device) || categoryOf(device) === 'done'
}

function normalActionLabel (device: ProvisioningDevice): string {
  const action = normalAction(device)
  if (action === 'execute') {
    return i18n.global.t('pages.gpsTrackerProvisioning.buttons.execute')
  }
  return i18n.global.t('pages.gpsTrackerProvisioning.buttons.retry')
}

function statusChipLabel (device: ProvisioningDevice): string {
  if (isTopicPending(device)) {
    return i18n.global.t('pages.gpsTrackerProvisioning.statusChips.topic_pending')
  }
  return categoryLabel(categoryOf(device))
}

function statusChipColor (device: ProvisioningDevice): string {
  return isTopicPending(device) ? TOPIC_PENDING_COLOR : CATEGORY_COLORS[categoryOf(device)]
}

function modelTypeLabel (modelType: number | null): string {
  return ALL_DEVICE_TYPE.find((type) => type.id === modelType)?.type ?? ''
}

function formatDateTime (value: string | null | undefined): string {
  if (!value) {
    return '—'
  }
  return moment(value).format('YYYY-MM-DD HH:mm')
}

// ---- 状態更新。表示中デバイスの状態だけ取り直す ----
const refreshDone = ref(false)
const refreshDoneTime = ref('')
let refreshDoneTimer: ReturnType<typeof setTimeout> | null = null

function refreshStatus () {
  if (listLoading.value || devices.value.length === 0) {
    return
  }
  listLoading.value = true
  const deviceIds = devices.value.map((device) => device.id)
  Api().refreshProvisioningStatuses(deviceIds).then((data) => {
    const refreshed = new Map<number, ProvisioningStatus | null>(
      data.gps_tracker_provisioning_statuses.map((item) => [item.id, item.provisioning_status])
    )
    devices.value.forEach((device) => {
      if (refreshed.has(device.id)) {
        device.provisioning_status = refreshed.get(device.id) ?? null
      }
    })
    refreshDoneTime.value = moment().format('HH:mm:ss')
    refreshDone.value = true
    if (refreshDoneTimer) {
      clearTimeout(refreshDoneTimer)
    }
    refreshDoneTimer = setTimeout(() => {
      refreshDone.value = false
    }, 10000)
  }).catch((error) => {
    handleError(error, 'fetchFailed')
  }).finally(() => {
    listLoading.value = false
  })
}

// ---- 一括実行の対象。絞り込みに関係なく有効デバイス全件 ----
// 件数はカテゴリ指定した一覧APIの total から取る。実行対象のIDは一括ボタンを押した時に全ページ辿って集める
const bulkTotals = reactive<Record<BulkCategory, number>>({ not_executed: 0, failed: 0 })
const bulkTargetsLoading = ref(false)

function buildBulkRequest (category: BulkCategory, page: number): getProvisioningStatusesRequest {
  return {
    operation_office_ids: [],
    model_number: null,
    fw_version: null,
    sim_id: null,
    imei: null,
    model_type: null,
    number_plate: null,
    only_active: true,
    provisioning_categories: [category],
    page,
  }
}

function loadBulkTotals () {
  Promise.all([
    Api().getProvisioningStatuses(buildBulkRequest('not_executed', 1)),
    Api().getProvisioningStatuses(buildBulkRequest('failed', 1)),
  ]).then(([notExecuted, failed]) => {
    bulkTotals.not_executed = notExecuted.total
    bulkTotals.failed = failed.total
  }).catch((error) => {
    handleError(error, 'fetchFailed')
  })
}

async function fetchAllDeviceIdsByCategory (category: BulkCategory): Promise<number[]> {
  const ids: number[] = []
  let page = 1
  let lastPage = 1
  do {
    const data = await Api().getProvisioningStatuses(buildBulkRequest(category, page))
    ids.push(...data.gps_tracker_provisioning_statuses.map((device) => device.id))
    lastPage = data.total_page
    page += 1
  } while (page <= lastPage)
  return ids
}

// ---- 選択。強制再実行の対象になるので全状態で選べる ----
const selectedIds: Ref<number[]> = ref([])
const selectableDeviceIds = computed(() => devices.value.map((device) => device.id))
const allSelected = computed(() =>
  selectableDeviceIds.value.length > 0 && selectableDeviceIds.value.every((id) => selectedIds.value.includes(id))
)

function toggleAll (event: Event) {
  const checked = (event.target as HTMLInputElement).checked
  selectedIds.value = checked ? [...selectableDeviceIds.value] : []
}

// ---- 実行確認 ----
const showModal = ref(false)
const executing = ref(false)
const pendingIds: Ref<number[]> = ref([])
const pendingCategory: Ref<BulkCategory | null> = ref(null)
const pendingForce = ref(false)
const pendingCategoryLabel = computed(() => pendingCategory.value ? categoryLabel(pendingCategory.value) : null)

// 対象のうち通常実行でスキップされる台数と、実行中の台数。モーダルの案内に使う
const pendingDevices = computed(() => {
  const pendingIdSet = new Set(pendingIds.value)
  return devices.value.filter((device) => pendingIdSet.has(device.id))
})
const pendingSkipCount = computed(() => pendingDevices.value.filter(isSkippedByNormalRun).length)
const pendingRunningCount = computed(() => pendingDevices.value.filter(isRunning).length)

function openModalForIds (ids: number[], force: boolean) {
  if (ids.length === 0) {
    props.showFlash(i18n.global.t('pages.gpsTrackerProvisioning.messages.selectDevice'), 'warn', false)
    return
  }
  pendingIds.value = ids
  pendingCategory.value = null
  pendingForce.value = force
  showModal.value = true
}

function openModalForCategory (category: BulkCategory) {
  if (bulkTargetsLoading.value) {
    return
  }
  bulkTargetsLoading.value = true
  fetchAllDeviceIdsByCategory(category).then((ids) => {
    bulkTotals[category] = ids.length
    if (ids.length === 0) {
      props.showFlash(i18n.global.t('pages.gpsTrackerProvisioning.messages.noBulkTargets'), 'warn', false)
      return
    }
    pendingIds.value = ids
    pendingCategory.value = category
    pendingForce.value = false
    showModal.value = true
  }).catch((error) => {
    handleError(error, 'fetchFailed')
  }).finally(() => {
    bulkTargetsLoading.value = false
  })
}

function openSelected () {
  openModalForIds([...selectedIds.value], false)
}

function openForceSelected () {
  openModalForIds([...selectedIds.value], true)
}

function openRow (device: ProvisioningDevice) {
  openModalForIds([device.id], false)
}

function openForceRow (device: ProvisioningDevice) {
  openModalForIds([device.id], true)
}

function openBulkNotExecuted () {
  openModalForCategory('not_executed')
}

function openRetryFailed () {
  openModalForCategory('failed')
}

// force は端末の状態ではなく押したボタンで決まる。実行APIの上限に合わせて50件ずつ送る
function chunkExecuteRequests (deviceIds: number[], force: boolean): executeProvisioningRequest[] {
  const requests: executeProvisioningRequest[] = []
  for (let index = 0; index < deviceIds.length; index += EXECUTE_CHUNK_SIZE) {
    requests.push({ device_ids: deviceIds.slice(index, index + EXECUTE_CHUNK_SIZE), force })
  }
  return requests
}

function buildExecuteRequests (): executeProvisioningRequest[] {
  return chunkExecuteRequests(pendingIds.value, pendingForce.value)
}

function execute () {
  showModal.value = false
  const requests = buildExecuteRequests()
  executing.value = true
  Promise.all(requests.map((request) => Api().executeProvisioning(request))).then((responses) => {
    const results = responses.flatMap((response) => response.results)
    const skippedCount = results.filter((result) => result.action === 'skipped').length
    const failedCount = results.filter((result) => result.action === 'failed').length
    // skipped は完了か実行中。失敗ではないのでそのまま案内する
    const messages = [i18n.global.t('pages.gpsTrackerProvisioning.messages.executed')]
    if (skippedCount > 0) {
      messages.push(i18n.global.t('pages.gpsTrackerProvisioning.messages.executeSkipped', { count: skippedCount }))
    }
    if (failedCount > 0) {
      messages.push(i18n.global.t('pages.gpsTrackerProvisioning.messages.executePartiallyFailed', { count: failedCount }))
    }
    props.showFlash(messages.join(' '), skippedCount > 0 || failedCount > 0 ? 'warn' : 'info', false)
    selectedIds.value = []
    refreshStatus()
    loadBulkTotals()
  }).catch((error) => {
    handleError(error, 'executeFailed')
  }).finally(() => {
    executing.value = false
    pendingIds.value = []
    pendingCategory.value = null
    pendingForce.value = false
  })
}

// ---- エラー ----
function handleError (error: any, messageKey: 'fetchFailed' | 'executeFailed') {
  const status = error?.response?.status
  if (status === 401) {
    loginWithRedirect({ appState: { targetUrl: location.pathname } })
    return
  }
  if (status === 403) {
    props.showFlash(i18n.global.t('pages.common.messages.forbidden'), 'error', false)
    return
  }
  // 422 は errors に項目ごとのメッセージが入る。実行APIの事前検証もここに来るので中身を見せる
  if (status === 422) {
    const errors = (error?.response?.data?.errors ?? {}) as Record<string, string[]>
    const validationMessages = Object.values(errors).flat().filter((message) => typeof message === 'string')
    if (validationMessages.length > 0) {
      props.showFlash(validationMessages.join(' '), 'error', false)
      return
    }
  }
  props.showFlash(i18n.global.t(`pages.gpsTrackerProvisioning.messages.${messageKey}`), 'error', false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.title')), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (selectedIds.value.length)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  class: "mt-0 mr-2 mb-1",
                  color: "#15829C",
                  disabled: executing.value,
                  onClick: openSelected
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.executeSelected', { count: selectedIds.value.length })), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (selectedIds.value.length)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  class: "mt-0 mr-2 mb-1",
                  color: FORCE_RERUN_COLOR,
                  disabled: executing.value,
                  onClick: openForceSelected
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.forceRerunSelected', { count: selectedIds.value.length })), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_btn, {
              class: "mt-0 mr-2 mb-1",
              color: "orange-darken-3",
              disabled: executing.value,
              loading: bulkTargetsLoading.value && pendingCategory.value === 'not_executed',
              onClick: openBulkNotExecuted
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.executeAllNotExecuted', { count: bulkTotals.not_executed })), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            _createVNode(_component_v_btn, {
              class: "mt-0 mr-1 mb-1",
              color: "blue-grey-darken-1",
              disabled: executing.value,
              loading: bulkTargetsLoading.value && pendingCategory.value === 'failed',
              onClick: openRetryFailed
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.retryAllFailed', { count: bulkTotals.failed })), 1)
              ]),
              _: 1
            }, 8, ["disabled", "loading"]),
            _createVNode(_component_v_tooltip, {
              location: "bottom",
              "open-on-click": "",
              "max-width": "360"
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                  icon: "mdi-information-outline",
                  size: "small",
                  color: "grey-darken-1",
                  class: "mb-1",
                  style: {"cursor":"pointer"}
                }), null, 16)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.tooltips.bulkScope')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_btn, {
              class: _normalizeClass(['refresh-btn', 'mr-3', 'mb-1', { 'refresh-btn--done': refreshDone.value }]),
              variant: "outlined",
              color: refreshDone.value ? 'success' : '#15829C',
              size: "small",
              "prepend-icon": refreshDone.value ? 'mdi-check-circle' : 'mdi-refresh',
              loading: listLoading.value,
              disabled: listLoading.value || refreshDone.value || devices.value.length === 0,
              onClick: refreshStatus
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(refreshDone.value
                  ? _unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.refreshDone', { time: refreshDoneTime.value })
                  : _unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.refreshStatus')), 1)
              ]),
              _: 1
            }, 8, ["class", "color", "prepend-icon", "loading", "disabled"]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                color: "warning",
                size: "small",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-alert-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", null, [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.notice.deviceManagementPrefix')) + " ", 1),
                _createVNode(_component_router_link, {
                  to: { name: 'DeviceList' },
                  class: "device-list-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.notice.deviceList')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.notice.deviceManagementSuffix')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (listLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_progress_circular, {
                  indeterminate: "",
                  color: "#15829C",
                  size: "48",
                  width: "4"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: allSelected.value,
                      disabled: selectableDeviceIds.value.length === 0,
                      onChange: toggleAll
                    }, null, 40, _hoisted_12)
                  ]),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.id')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.provisioningStatus')), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.failureReason')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.lastExecutedAt')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.modelNumber')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.deviceId')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.simId')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.imei')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.modelType')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.fw')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.managementOfficeName')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.operationOfficeName')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.devices.installationCar')), 1),
                  _createElementVNode("th", null, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.executedBy')), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.actions')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (!listLoading.value && devices.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.messages.noData')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(devices.value, (device) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: device.id
                  }, [
                    _createElementVNode("td", _hoisted_17, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: device.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIds).value = $event))
                      }, null, 8, _hoisted_18), [
                        [_vModelCheckbox, selectedIds.value]
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(device.id), 1),
                    _createElementVNode("td", null, [
                      (isTopicPending(device))
                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                            key: 0,
                            location: "bottom",
                            "max-width": "320"
                          }, {
                            activator: _withCtx(({ props: tooltipProps }) => [
                              _createElementVNode("span", _mergeProps({ ref_for: true }, tooltipProps, {
                                class: "status-chip",
                                style: { backgroundColor: statusChipColor(device), cursor: 'help' }
                              }), _toDisplayString(statusChipLabel(device)), 17)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.tooltips.topicPending')), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "status-chip",
                            style: _normalizeStyle({ backgroundColor: statusChipColor(device) })
                          }, _toDisplayString(statusChipLabel(device)), 5))
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      (categoryOf(device) === 'failed')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(failureReasonLabel(device)), 1))
                        : (categoryOf(device) === 'done')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "—"))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(formatDateTime(device.provisioning_status?.updated_at)), 1),
                    _createElementVNode("td", null, _toDisplayString(device.model_number), 1),
                    _createElementVNode("td", null, _toDisplayString(device.device_id), 1),
                    _createElementVNode("td", null, _toDisplayString(device.sim_id), 1),
                    _createElementVNode("td", null, _toDisplayString(device.imei ?? ''), 1),
                    _createElementVNode("td", null, _toDisplayString(modelTypeLabel(device.model_type)), 1),
                    _createElementVNode("td", null, _toDisplayString(device.firmware_version ?? ''), 1),
                    _createElementVNode("td", null, _toDisplayString(device.management_office_name ?? ''), 1),
                    _createElementVNode("td", null, _toDisplayString(device.operation_office_name ?? ''), 1),
                    _createElementVNode("td", null, _toDisplayString(device.installation_vehicle_number_plate ?? ''), 1),
                    _createElementVNode("td", null, _toDisplayString(device.provisioning_status?.account_name ?? ''), 1),
                    _createElementVNode("td", _hoisted_22, [
                      _createVNode(_component_v_menu, null, {
                        activator: _withCtx(({ props: menuProps }) => [
                          _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, menuProps, {
                            class: "action-menu-btn",
                            variant: "outlined",
                            color: "#15829C",
                            "append-icon": "mdi-chevron-down",
                            disabled: executing.value
                          }), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.actions')), 1)
                            ]),
                            _: 1
                          }, 16, ["disabled"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, null, {
                            default: _withCtx(() => [
                              (normalAction(device))
                                ? (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: 0,
                                    onClick: ($event: any) => (openRow(device))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(normalActionLabel(device)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_list_item, {
                                onClick: ($event: any) => (openForceRow(device))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.buttons.forceRerun')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode(PaginateWithCount, {
          class: "justify-end",
          totalPage: totalPage.value,
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
          showItemCount: false
        }, null, 8, ["totalPage", "modelValue"]),
        _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("h4", _hoisted_25, _toDisplayString(_unref(i18n).global.t('pages.common.filter.title')), 1),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(ManagementOfficeAutoComplete, {
          modelValue: form.managementOffice,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.managementOffice) = $event)),
          selectFirstIfOnlyOne: ""
        }, null, 8, ["modelValue"]),
        _createVNode(MultipleOperationOfficeAutoComplete, {
          modelValue: form.operationOffices,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.operationOffices) = $event)),
          managementOffice: form.managementOffice
        }, null, 8, ["modelValue", "managementOffice"]),
        _createVNode(_component_v_text_field, {
          label: _unref(i18n).global.t('pages.devices.modelNumber'),
          modelValue: form.model_number,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.model_number) = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_v_text_field, {
          label: _unref(i18n).global.t('pages.devices.fwVersion'),
          modelValue: form.fw_version,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.fw_version) = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_v_text_field, {
          label: _unref(i18n).global.t('pages.devices.simId'),
          modelValue: form.sim_id,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.sim_id) = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(_component_v_text_field, {
          label: _unref(i18n).global.t('pages.devices.imei'),
          modelValue: form.imei,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.imei) = $event))
        }, null, 8, ["label", "modelValue"]),
        _createVNode(SingleDeviceTypeAutoComplete, {
          modelValue: form.model_type,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.model_type) = $event)),
          makerId: _unref(TELTONIKA_MAKER_ID)
        }, null, 8, ["modelValue", "makerId"]),
        _createVNode(_component_v_autocomplete, {
          label: _unref(i18n).global.t('pages.gpsTrackerProvisioning.filters.numberPlate'),
          modelValue: form.number_plate,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.number_plate) = $event)),
          items: numberPlateOptions.value,
          clearable: ""
        }, null, 8, ["label", "modelValue", "items"]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(i18n).global.t('pages.devices.status')), 1),
          _createVNode(_component_v_radio_group, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.status) = $event)),
            class: "radio-group-row"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_radio, {
                value: "only-active",
                label: _unref(i18n).global.t('pages.common.filter.status.onlyActive'),
                color: "blue"
              }, null, 8, ["label"]),
              _createVNode(_component_v_radio, {
                value: "all",
                label: _unref(i18n).global.t('pages.common.filter.status.all'),
                color: "blue"
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerProvisioning.columns.provisioningStatus')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PROVISIONING_CATEGORIES), (category) => {
            return (_openBlock(), _createElementBlock("div", {
              key: category,
              class: "d-flex align-center"
            }, [
              _createVNode(_component_v_checkbox, {
                id: `provisioning-category-${category}`,
                modelValue: form.categories,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.categories) = $event)),
                value: category,
                class: "flex-grow-0",
                color: "blue",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["id", "modelValue", "value"]),
              _createElementVNode("label", {
                for: `provisioning-category-${category}`,
                class: "category-label"
              }, _toDisplayString(categoryLabel(category)), 9, _hoisted_29)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_v_btn, {
          class: "ma-2 exec-btn",
          disabled: listLoading.value,
          style: _normalizeStyle({ backgroundColor: listLoading.value ? '#B3B8BB' : '' }),
          onClick: search
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(listLoading.value ? _unref(i18n).global.t('pages.common.button.loading') : _unref(i18n).global.t('pages.common.button.exec')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "style"]),
        _createVNode(_component_v_btn, {
          class: "ma-2 reset-btn",
          disabled: listLoading.value,
          onClick: clearFilter
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode(BulkProvisioningConfirmModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showModal).value = $event)),
      deviceIds: pendingIds.value,
      categoryLabel: pendingCategoryLabel.value,
      force: pendingForce.value,
      skipCount: pendingSkipCount.value,
      runningCount: pendingRunningCount.value,
      onConfirm: execute
    }, null, 8, ["modelValue", "deviceIds", "categoryLabel", "force", "skipCount", "runningCount"])
  ]))
}
}

})